import { resolveContextMenuTarget } from 'utils/right-click-pan';

export const CONTEXT_MENU_ROOT_SELECTOR = '[data-app-context-menu]';

export function isInsideContextMenu(target: EventTarget | null): boolean {
  const element = resolveContextMenuTarget(target);
  return (
    element != null && element.closest(CONTEXT_MENU_ROOT_SELECTOR) !== null
  );
}

export function shouldCloseContextMenuOnPress(
  visible: boolean,
  target: EventTarget | null
): boolean {
  if (!visible) {
    return false;
  }
  return !isInsideContextMenu(target);
}
